import React from "react";
import {Box, useMediaQuery} from "@mui/material";
import {conferenceId, toolpressServerUrl} from "../configuration";
import useAxios from "axios-hooks";
import {LangSwitcher} from "../components/LangSwitcher";

export const LogoHeader = ({children}) => {
    const isMobile = useMediaQuery(`(max-width: 760px)`);

    const [{data: logoUrl, loading: loadingLogo, error: errorLogo}] = useAxios({
        url: `${toolpressServerUrl}/${conferenceId}/logo`,
        method: 'GET'
    })



    return(

        <Box>

            <Box sx={{position:'absolute', top:'1rem', right:'1rem'}}>
                <LangSwitcher/>

            </Box>
            <Box sx={{textAlign:'center', width:'100%', pt:10, overflow:'visible'}}>
                <img src={'/assets/logo-btogether-25.png'} style={{width: '100%', maxWidth: '250px', marginBottom:'1.5rem',overflow:'visible'}}/>
                {children}
            </Box>
        </Box>
    )
}
